import { render, staticRenderFns } from "./TwinkleEffect.vue?vue&type=template&id=6a3abf10&scoped=true"
import script from "./TwinkleEffect.vue?vue&type=script&lang=ts"
export * from "./TwinkleEffect.vue?vue&type=script&lang=ts"
import style0 from "./TwinkleEffect.vue?vue&type=style&index=0&id=6a3abf10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3abf10",
  null
  
)

export default component.exports